var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_vm._l((_vm.cards),function(card){return [_c('app-vehicles-track-cards',{attrs:{"title":card.title,"value":card.value,"tooltip":card.tooltip}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }